import AxiosWrapper from '@/helpers/axios-wrapper'


/**
 * @returns Promise
 */
export function detail() {
    return AxiosWrapper('/marketplace/params/detail/', {});
}